<template>
  <div v-if="$store.state.user" class="container portal">
    <SidebarNav />
    <div class="content"><header class="portal-account"><span>{{ $store.state.user.name_org }}</span><div class="portal-account-actions"><CommentNotifications /><button class="btn btn-outline" :disabled="busy" @click="logout">Выйти</button></div></header>
      <p v-if="error" class="error" role="alert">{{ error }}</p>
      <main id="content"><router-view :key="$route.path" /></main><footer>ООО "Бизнес решение"</footer>
    </div>
  </div>
</template>
<script>
import SidebarNav from '@/components/SidebarNav.vue'
import CommentNotifications from '@/components/CommentNotifications.vue'
export default {
  components: { SidebarNav, CommentNotifications },
  data: () => ({ busy: false, error: '' }),
  methods: {
    async logout() {
      this.busy = true; this.error = ''
      try { await this.$store.dispatch('logout'); await this.$router.replace('/login') }
      catch (error) { this.error = error.message }
      finally { this.busy = false }
    }
  }
}
</script>
<style scoped>
.portal-account-actions { display: flex; align-items: center; gap: 14px; flex-shrink: 0; }
.portal-account > span { min-width: 0; overflow-wrap: anywhere; font-weight: bold; font-size: 30px; color:#000; }
</style>
